export const quizQuestions = {
  'aml-foundations': {
    'en': [
      {
        question: 'What does AML stand for?',
        options: ['Anti-Money Laundering', 'Alternative Markets Listing', 'Advanced Marketing Leverage', 'Asset Management Ltd'],
        correctAnswer: 0,
        explanation: 'AML stands for Anti-Money Laundering, which refers to regulations and procedures to prevent money laundering.'
      },
      {
        question: 'What is the SAR reporting threshold?',
        options: ['$1,000', '$5,000', '$10,000', '$50,000'],
        correctAnswer: 1,
        explanation: 'Suspicious Activity Reports (SARs) must be filed for suspicious activities involving transactions over $5,000.'
      },
      {
        question: 'Which of the following is NOT a red flag for money laundering?',
        options: ['Structuring deposits under reporting threshold', 'Customer making large deposits without business justification', 'Customer conducting normal business transactions', 'Rapid wire transfers to high-risk countries'],
        correctAnswer: 2,
        explanation: 'Normal business transactions are legitimate activities, not red flags. The other options are all common AML red flags.'
      },
      {
        question: 'What is structuring in AML?',
        options: ['Organizing a company structure', 'Deliberately breaking up deposits to avoid reporting thresholds', 'Creating a new business structure', 'Organizing customer files'],
        correctAnswer: 1,
        explanation: 'Structuring (smurfing) is the practice of breaking large sums of money into smaller deposits to avoid triggering reporting requirements.'
      },
      {
        question: 'Who is responsible for AML compliance in a financial institution?',
        options: ['Only the compliance department', 'Only senior management', 'Everyone working at the institution', 'Only customer-facing employees'],
        correctAnswer: 2,
        explanation: 'AML compliance is everyone\'s responsibility. All employees should be trained to recognize and report suspicious activities.'
      },
      {
        question: 'What are the three stages of money laundering?',
        options: ['Detection, Investigation, Prosecution', 'Placement, Layering, Integration', 'Collection, Processing, Distribution', 'Opening, Managing, Closing'],
        correctAnswer: 1,
        explanation: 'Money laundering typically involves: Placement (getting money into financial system), Layering (moving it around to obscure origin), and Integration (reintroducing it as clean).'
      },
      {
        question: 'What is BSA compliance?',
        options: ['Bank Secrecy Act - requires reporting of financial transactions', 'Business Security Audit - internal security review', 'Balance Sheet Analysis - financial review', 'Biometric Security Authorization - access control'],
        correctAnswer: 0,
        explanation: 'The Bank Secrecy Act (BSA) requires financial institutions to report certain transactions to help detect and prevent money laundering and terrorism financing.'
      },
      {
        question: 'How long must AML records be retained?',
        options: ['1 year', '3 years', '5 years', '10 years'],
        correctAnswer: 2,
        explanation: 'Financial institutions must retain records of transactions for at least 5 years to comply with AML regulations.'
      },
      {
        question: 'What is the primary purpose of KYC (Know Your Customer)?',
        options: ['To increase customer base', 'To identify and verify customer identity and assess AML risk', 'To improve marketing effectiveness', 'To reduce operational costs'],
        correctAnswer: 1,
        explanation: 'KYC procedures are essential to verify customer identity, understand their business, and assess their AML and compliance risk.'
      },
      {
        question: 'What should you do if you suspect money laundering?',
        options: ['Ignore it if the customer is important', 'Report it immediately to compliance/management', 'Ask the customer directly about it', 'Wait to see if it continues'],
        correctAnswer: 1,
        explanation: 'Suspected money laundering must be reported immediately to your compliance department or designated AML officer. Do not tip off the customer.'
      }
    ],
    'es': [
      {
        question: '¿Qué significa AML?',
        options: ['Anti-Lavado de Dinero', 'Listado de Mercados Alternativos', 'Apalancamiento Avanzado de Marketing', 'Gestión de Activos Ltd'],
        correctAnswer: 0,
        explanation: 'AML significa Anti-Lavado de Dinero, que se refiere a las regulaciones y procedimientos para prevenir el lavado de dinero.'
      },
      {
        question: '¿Cuál es el umbral de presentación de SAR?',
        options: ['$1,000', '$5,000', '$10,000', '$50,000'],
        correctAnswer: 1,
        explanation: 'Los Reportes de Actividad Sospechosa (SAR) deben presentarse para actividades sospechosas que superen los $5,000.'
      },
      {
        question: '¿Cuál de los siguientes NO es una bandera roja para lavado de dinero?',
        options: ['Depósitos estructurados por debajo del umbral de reporte', 'Cliente realizando grandes depósitos sin justificación comercial', 'Cliente realizando transacciones normales de negocios', 'Transferencias rápidas a países de alto riesgo'],
        correctAnswer: 2,
        explanation: 'Las transacciones comerciales normales son actividades legítimas, no banderas rojas. Las otras opciones son todas banderas rojas comunes de AML.'
      },
      {
        question: '¿Qué es la estructuración en AML?',
        options: ['Organizar una estructura empresarial', 'Dividir deliberadamente depósitos para evitar umbrales de reporte', 'Crear una nueva estructura empresarial', 'Organizar archivos de clientes'],
        correctAnswer: 1,
        explanation: 'La estructuración (smurfing) es la práctica de dividir sumas grandes de dinero en depósitos más pequeños para evitar activar requisitos de reporte.'
      },
      {
        question: '¿Quién es responsable del cumplimiento de AML en una institución financiera?',
        options: ['Solo el departamento de cumplimiento', 'Solo la alta gerencia', 'Todos los que trabajan en la institución', 'Solo empleados orientados al cliente'],
        correctAnswer: 2,
        explanation: 'El cumplimiento de AML es responsabilidad de todos. Todos los empleados deben ser capacitados para reconocer y reportar actividades sospechosas.'
      },
      {
        question: '¿Cuáles son las tres etapas del lavado de dinero?',
        options: ['Detección, Investigación, Procesamiento', 'Colocación, Estratificación, Integración', 'Recopilación, Procesamiento, Distribución', 'Apertura, Gestión, Cierre'],
        correctAnswer: 1,
        explanation: 'El lavado de dinero generalmente implica: Colocación (introducir dinero en el sistema financiero), Estratificación (moverlo para obscurecer el origen) e Integración (reintroducirlo como limpio).'
      },
      {
        question: '¿Qué es cumplimiento de la BSA?',
        options: ['Ley de Secreto Bancario - requiere reportar transacciones financieras', 'Auditoría de Seguridad Empresarial - revisión de seguridad interna', 'Análisis de Balance General - revisión financiera', 'Autorización de Seguridad Biométrica - control de acceso'],
        correctAnswer: 0,
        explanation: 'La Ley de Secreto Bancario (BSA) requiere que las instituciones financieras reporten ciertas transacciones para detectar y prevenir lavado de dinero y financiamiento del terrorismo.'
      },
      {
        question: '¿Cuánto tiempo deben retenerse los registros de AML?',
        options: ['1 año', '3 años', '5 años', '10 años'],
        correctAnswer: 2,
        explanation: 'Las instituciones financieras deben retener registros de transacciones durante al menos 5 años para cumplir con las regulaciones de AML.'
      },
      {
        question: '¿Cuál es el propósito principal de KYC (Conocer a su Cliente)?',
        options: ['Aumentar la base de clientes', 'Identificar y verificar la identidad del cliente y evaluar el riesgo de AML', 'Mejorar la efectividad del marketing', 'Reducir costos operativos'],
        correctAnswer: 1,
        explanation: 'Los procedimientos de KYC son esenciales para verificar la identidad del cliente, comprender su negocio y evaluar su riesgo de AML y cumplimiento.'
      },
      {
        question: '¿Qué debe hacer si sospecha lavado de dinero?',
        options: ['Ignorarlo si el cliente es importante', 'Reportarlo inmediatamente al departamento de cumplimiento/gerencia', 'Preguntar directamente al cliente al respecto', 'Esperar para ver si continúa'],
        correctAnswer: 1,
        explanation: 'El lavado de dinero sospechoso debe reportarse inmediatamente a su departamento de cumplimiento u oficial de AML designado. No alerte al cliente.'
      }
    ],
    'pt': [
      {
        question: 'O que significa AML?',
        options: ['Prevenção de Lavagem de Dinheiro', 'Listagem de Mercados Alternativos', 'Alavancagem Avançada de Marketing', 'Gestão de Ativos Ltd'],
        correctAnswer: 0,
        explanation: 'AML significa Prevenção de Lavagem de Dinheiro, que se refere às regulamentações e procedimentos para prevenir a lavagem de dinheiro.'
      },
      {
        question: 'Qual é o limite de apresentação de SAR?',
        options: ['$1.000', '$5.000', '$10.000', '$50.000'],
        correctAnswer: 1,
        explanation: 'Os Relatórios de Atividade Suspeita (SAR) devem ser apresentados para atividades suspeitas envolvendo transações acima de $5.000.'
      },
      {
        question: 'Qual dos seguintes NÃO é um sinal de alerta para lavagem de dinheiro?',
        options: ['Depósitos estruturados abaixo do limite de relatório', 'Cliente fazendo grandes depósitos sem justificação comercial', 'Cliente realizando transações comerciais normais', 'Transferências rápidas para países de alto risco'],
        correctAnswer: 2,
        explanation: 'As transações comerciais normais são atividades legítimas, não sinais de alerta. As outras opções são todas sinais de alerta comuns de AML.'
      },
      {
        question: 'O que é estruturação em AML?',
        options: ['Organizar uma estrutura de empresa', 'Dividir deliberadamente depósitos para evitar limites de relatório', 'Criar uma nova estrutura de negócio', 'Organizar arquivos de clientes'],
        correctAnswer: 1,
        explanation: 'A estruturação (smurfing) é a prática de dividir grandes quantidades de dinheiro em depósitos menores para evitar desencadear requisitos de relatório.'
      },
      {
        question: 'Quem é responsável pelo cumprimento de AML em uma instituição financeira?',
        options: ['Apenas o departamento de conformidade', 'Apenas a alta gestão', 'Todos os que trabalham na instituição', 'Apenas funcionários que lidam com clientes'],
        correctAnswer: 2,
        explanation: 'O cumprimento de AML é responsabilidade de todos. Todos os funcionários devem ser treinados para reconhecer e reportar atividades suspeitas.'
      },
      {
        question: 'Quais são os três estágios da lavagem de dinheiro?',
        options: ['Detecção, Investigação, Processamento', 'Colocação, Estratificação, Integração', 'Coleta, Processamento, Distribuição', 'Abertura, Gestão, Fechamento'],
        correctAnswer: 1,
        explanation: 'A lavagem de dinheiro geralmente envolve: Colocação (introduzir dinheiro no sistema financeiro), Estratificação (movimentar para obscurecer a origem) e Integração (reintroduzir como limpo).'
      },
      {
        question: 'O que é conformidade com a BSA?',
        options: ['Lei do Sigilo Bancário - requer relatório de transações financeiras', 'Auditoria de Segurança Empresarial - revisão de segurança interna', 'Análise de Balanço Patrimonial - revisão financeira', 'Autorização de Segurança Biométrica - controle de acesso'],
        correctAnswer: 0,
        explanation: 'A Lei do Sigilo Bancário (BSA) exige que as instituições financeiras relatem certas transações para ajudar a detectar e prevenir lavagem de dinheiro e financiamento do terrorismo.'
      },
      {
        question: 'Por quanto tempo os registros de AML devem ser retidos?',
        options: ['1 ano', '3 anos', '5 anos', '10 anos'],
        correctAnswer: 2,
        explanation: 'As instituições financeiras devem reter registros de transações por pelo menos 5 anos para cumprir as regulamentações de AML.'
      },
      {
        question: 'Qual é o objetivo principal do KYC (Conhecer Seu Cliente)?',
        options: ['Aumentar a base de clientes', 'Identificar e verificar a identidade do cliente e avaliar o risco de AML', 'Melhorar a eficácia do marketing', 'Reduzir custos operacionais'],
        correctAnswer: 1,
        explanation: 'Os procedimentos de KYC são essenciais para verificar a identidade do cliente, entender seus negócios e avaliar seu risco de AML e conformidade.'
      },
      {
        question: 'O que você deve fazer se suspeitar de lavagem de dinheiro?',
        options: ['Ignorar se o cliente é importante', 'Reportar imediatamente ao departamento de conformidade/gestão', 'Perguntar diretamente ao cliente sobre isso', 'Aguardar para ver se continua'],
        correctAnswer: 1,
        explanation: 'A lavagem de dinheiro suspeita deve ser reportada imediatamente ao seu departamento de conformidade ou oficial de AML designado. Não alerte o cliente.'
      }
    ]
  },
  'AML Foundations': {
    'en': [], // Will be populated by reference to 'aml-foundations'
    'es': [],
    'pt': []
  },

  'Know Your Customer (KYC)': [
    {
      question: 'What does KYC stand for?',
      options: ['Keep Your Customers', 'Know Your Client', 'Key Yield Currency', 'Knowledge Year Calendar'],
      correctAnswer: 1,
      explanation: 'KYC stands for Know Your Client/Customer, a fundamental compliance requirement.'
    },
    {
      question: 'What is the primary goal of KYC?',
      options: ['Increase transaction volume', 'Identify and verify customer identity and assess risk', 'Reduce customer complaints', 'Lower operational costs'],
      correctAnswer: 1,
      explanation: 'KYC aims to verify customer identity and assess their AML and compliance risks.'
    },
    {
      question: 'Which documents are acceptable for customer identity verification? (Select all applicable)',
      options: ['Passport', 'Driver\'s License', 'Social Media Profile', 'Utility Bill'],
      correctAnswer: 0,
      explanation: 'Government-issued IDs like passports and driver\'s licenses are acceptable. Social media profiles are not official documents.'
    },
    {
      question: 'What is beneficial ownership?',
      options: ['Owning shares that generate profit', 'Owning the most shares in a company', 'The natural person(s) who ultimately own/control a company', 'Owning multiple businesses'],
      correctAnswer: 2,
      explanation: 'Beneficial ownership refers to the actual person(s) who ultimately own or control a legal entity, which must be identified and verified.'
    },
    {
      question: 'How often should KYC information be updated?',
      options: ['Never - once collected, it doesn\'t need updating', 'Every 10 years', 'Every 3-5 years or when significant changes occur', 'Only if the customer requests it'],
      correctAnswer: 2,
      explanation: 'KYC information should be updated regularly (typically every 3-5 years) and whenever significant changes in customer circumstances occur.'
    },
    {
      question: 'What is PEP in KYC context?',
      options: ['Personal Exemption Program', 'Politically Exposed Person - high-risk individual in government', 'Pre-Employment Procedure', 'Personal Expense Policy'],
      correctAnswer: 1,
      explanation: 'PEPs (Politically Exposed Persons) are individuals with prominent government or political roles and require enhanced due diligence.'
    },
    {
      question: 'What is Enhanced Due Diligence (EDD)?',
      options: ['Standard KYC process', 'Additional scrutiny for high-risk customers', 'Annual compliance audit', 'Customer satisfaction survey'],
      correctAnswer: 1,
      explanation: 'EDD involves more thorough investigation and monitoring for high-risk customers such as PEPs, high-net-worth individuals, or those from high-risk jurisdictions.'
    },
    {
      question: 'What information should be collected during KYC?',
      options: ['Only account number and phone', 'Identity, address, source of funds, business purpose, beneficial ownership', 'Only customer name', 'Whatever the customer wants to provide'],
      correctAnswer: 1,
      explanation: 'KYC should collect comprehensive information including identity, address, source of funds, business purpose, and beneficial ownership details.'
    },
    {
      question: 'What is the consequence of inadequate KYC?',
      options: ['Customer satisfaction issues', 'Regulatory penalties, fines, and reputational damage for the institution', 'Increased customer loyalty', 'Lower compliance costs'],
      correctAnswer: 1,
      explanation: 'Inadequate KYC can result in significant regulatory penalties, large fines, and damage to institutional reputation.'
    },
    {
      question: 'When should KYC be completed?',
      options: ['After the first transaction', 'During the onboarding process, before opening the account', 'Whenever the compliance department requests it', 'Only for large customers'],
      correctAnswer: 1,
      explanation: 'KYC should be completed as part of the onboarding process before the customer account is fully opened and activated.'
    }
  ],

  'Sanctions & OFAC Compliance': [
    {
      question: 'What does OFAC stand for?',
      options: ['Office of Foreign Assets Control', 'Official Financial Audit Committee', 'Organization for Financial Activity Control', 'Overseas Financial Assessment Center'],
      correctAnswer: 0,
      explanation: 'OFAC (Office of Foreign Assets Control) is part of the U.S. Treasury Department and administers economic and trade sanctions.'
    },
    {
      question: 'What is the SDN list?',
      options: ['Securities Distribution Network', 'Specially Designated Nationals - blocked individuals/entities', 'Sanctions Determination Notice', 'Strategic Denial Notification'],
      correctAnswer: 1,
      explanation: 'The SDN (Specially Designated Nationals) list contains individuals and entities with whom U.S. persons/entities cannot do business.'
    },
    {
      question: 'What should you do if you identify a customer on a sanctions list?',
      options: ['Ignore it to avoid issues', 'Block the account immediately and report to compliance', 'Ask the customer about it', 'Continue normal business'],
      correctAnswer: 1,
      explanation: 'If a sanctioned entity is identified, you must immediately block transactions and report to compliance. Continued business with sanctioned parties is illegal.'
    },
    {
      question: 'How often should customers be screened against sanctions lists?',
      options: ['Only at account opening', 'At opening and periodically during ongoing relationship', 'Never - it\'s too resource-intensive', 'Only for large accounts'],
      correctAnswer: 1,
      explanation: 'Customers must be screened at account opening and periodically during the customer relationship to catch new sanctions designations.'
    },
    {
      question: 'What is a false positive in sanctions screening?',
      options: ['A customer who passes the screening', 'A name match that is not actually the sanctioned party', 'A failed compliance test', 'An intentional sanctions violation'],
      correctAnswer: 1,
      explanation: 'A false positive occurs when a customer name matches a sanctions list entry but it\'s a different person, requiring manual investigation to clear.'
    },
    {
      question: 'Which transactions require sanctions screening?',
      options: ['Only large wire transfers', 'Only international transactions', 'All customer transactions and counterparties', 'Only high-risk customer transactions'],
      correctAnswer: 2,
      explanation: 'All transactions and counterparties must be screened against sanctions lists, regardless of amount or customer risk profile.'
    },
    {
      question: 'What are comprehensive sanctions?',
      options: ['Sanctions on specific individuals', 'Broad sanctions on entire countries or sectors', 'Sanctions that affect only banking', 'Temporary sanctions lasting less than 1 year'],
      correctAnswer: 1,
      explanation: 'Comprehensive sanctions impose broad restrictions on an entire country or sector (e.g., Iran), affecting virtually all business dealings.'
    },
    {
      question: 'What is the 50% Rule in sanctions compliance?',
      options: ['Check 50% of transactions', 'Any entity owned 50%+ by a sanctioned party is blocked', 'Screen every other day', 'Apply to customers with 50%+ of assets abroad'],
      correctAnswer: 1,
      explanation: 'The 50% Rule states that any entity that is owned or controlled 50% or more by a sanctioned party is also blocked from business.'
    },
    {
      question: 'What happens if a transaction with a sanctioned party is missed?',
      options: ['Nothing - it\'s just a compliance formality', 'Severe regulatory penalties, large fines, and potential criminal liability', 'Customer is simply asked to report it', 'The transaction is reversed'],
      correctAnswer: 1,
      explanation: 'Missing sanctions violations can result in severe OFAC penalties (up to $250,000+ per violation) and potential criminal prosecution.'
    },
    {
      question: 'How should sanctions screening matches be handled?',
      options: ['Approve immediately', 'Refer to compliance for investigation and determination', 'Contact the customer to inquire', 'Reject all matches automatically'],
      correctAnswer: 1,
      explanation: 'All sanctions screening matches must be referred to compliance for thorough investigation to determine if it\'s a true positive or false positive before action.'
    }
  ],

  'Suspicious Activity Reporting (SAR)': [
    {
      question: 'What is a SAR?',
      options: ['Sales Activity Report', 'Suspicious Activity Report filed with FinCEN', 'System Audit Record', 'Security Assessment Review'],
      correctAnswer: 1,
      explanation: 'A SAR (Suspicious Activity Report) is filed with FinCEN when transactions meet suspicious thresholds, typically involving $5,000+ and suspicious indicators.'
    },
    {
      question: 'What is the SAR reporting threshold?',
      options: ['$1,000', '$5,000', '$10,000', '$25,000'],
      correctAnswer: 1,
      explanation: 'SARs must be filed for suspicious activities involving transactions of $5,000 or more.'
    },
    {
      question: 'How many days do you have to file a SAR after detection?',
      options: ['30 days', '60 days (can be extended in some cases)', '90 days', '1 year'],
      correctAnswer: 1,
      explanation: 'SARs must typically be filed within 30 days of detection, though this can be extended up to 60 days in specific circumstances.'
    },
    {
      question: 'What is the confidentiality requirement for SARs?',
      options: ['SARs are public records', 'SARs must be kept confidential - cannot be disclosed to the customer', 'Share with customer before filing', 'Post on company website'],
      correctAnswer: 1,
      explanation: 'SAR filing is confidential and must not be disclosed to the customer (no "tipping off" requirement). Violation can result in severe penalties.'
    },
    {
      question: 'Who can access SAR information internally?',
      options: ['All employees', 'Only those with legitimate business need', 'Only senior management', 'The customer can request access'],
      correctAnswer: 1,
      explanation: 'SAR information should be restricted to employees with legitimate business need to know, to maintain confidentiality and prevent tipping off.'
    },
    {
      question: 'What is structuring in the context of SAR?',
      options: ['Building business structure', 'Breaking deposits into smaller amounts to avoid SAR threshold', 'Organizing office structure', 'Creating a new business'],
      correctAnswer: 1,
      explanation: 'Structuring is deliberately breaking deposits into smaller amounts to avoid triggering SAR reporting, which itself is suspicious and reportable.'
    },
    {
      question: 'What information must be included in a SAR?',
      options: ['Optional details', 'Customer name, description of activity, amount, date, and indicators of suspicion', 'Only the transaction amount', 'Guess about the customer\'s intentions'],
      correctAnswer: 1,
      explanation: 'A SAR must include: customer information, detailed narrative of suspicious activity, transaction amounts, dates, and specific indicators of suspicion.'
    },
    {
      question: 'What is NOT a typical reason for SAR filing?',
      options: ['Money laundering indicators', 'Terrorist financing concerns', 'Customer asking to invest in low-return safe products', 'Sanctions violations'],
      correctAnswer: 2,
      explanation: 'Asking to invest in safe products is normal banking. SARs are filed for suspicious activities like money laundering, terrorist financing, and sanctions violations.'
    },
    {
      question: 'What penalties apply for failing to file a required SAR?',
      options: ['None', 'Civil penalties up to $100,000+ per violation and potential criminal liability', 'Minor administrative warning', 'Customer complaint filing'],
      correctAnswer: 1,
      explanation: 'Failing to file required SARs can result in significant civil penalties and potential criminal prosecution for the institution and individuals.'
    },
    {
      question: 'What should you do if you suspect illegal activity but are unsure if it meets SAR threshold?',
      options: ['Do nothing', 'Report to compliance for evaluation - when in doubt, report', 'Only report if you\'re certain', 'Wait for the customer to admit it'],
      correctAnswer: 1,
      explanation: 'When in doubt about whether to file a SAR, always report to compliance for evaluation. It\'s better to err on the side of caution.'
    }
  ],

  'transaction-monitoring': [
    {
      question: 'What is the purpose of transaction monitoring?',
      options: ['Increase processing fees', 'Detect suspicious patterns and AML red flags', 'Slow down customer service', 'Create additional paperwork'],
      correctAnswer: 1,
      explanation: 'Transaction monitoring detects suspicious transaction patterns and activities that may indicate money laundering or other financial crimes.'
    },
    {
      question: 'What are typical transaction monitoring rules?',
      options: ['Arbitrary limitations', 'Threshold-based (e.g., >$50k), pattern-based, and behavioral rules', 'No rules needed', 'Customer preferences'],
      correctAnswer: 1,
      explanation: 'Effective monitoring uses threshold-based rules (large amounts), pattern-based rules (rapid movements), and behavioral rules (changes in activity).'
    },
    {
      question: 'What is a false positive in transaction monitoring?',
      options: ['A legitimate transaction flagged as suspicious', 'A suspicious transaction that goes undetected', 'A customer complaint', 'A system error'],
      correctAnswer: 0,
      explanation: 'A false positive is a legitimate transaction that triggers a monitoring alert, requiring investigation to clear.'
    },
    {
      question: 'What should be the next step after a transaction is flagged?',
      options: ['Immediately block the transaction', 'Investigate to determine if truly suspicious', 'Ignore it', 'Notify the customer'],
      correctAnswer: 1,
      explanation: 'Flagged transactions should be investigated thoroughly to determine if they\'re genuinely suspicious or false positives.'
    },
    {
      question: 'How does behavioral monitoring work?',
      options: ['Monitor customer behavior outside of banking', 'Track changes in customer transaction patterns from their baseline', 'Listen to customer calls', 'Track customer location'],
      correctAnswer: 1,
      explanation: 'Behavioral monitoring detects unusual changes in a customer\'s transaction patterns compared to their established baseline activity.'
    },
    {
      question: 'What is a transaction with a high-risk jurisdiction?',
      options: ['Any international transaction', 'Transactions involving countries with weak AML controls or sanction risks', 'Transactions that cross state lines', 'Large wire transfers'],
      correctAnswer: 1,
      explanation: 'High-risk jurisdictions are countries with weak AML controls, corruption, or involved in sanctions. Transactions to/from these need enhanced monitoring.'
    },
    {
      question: 'How often should monitoring rules be reviewed and updated?',
      options: ['Never - set once and forget', 'Regularly (quarterly/annually) based on evolving threats and patterns', 'Only when there\'s a major incident', 'Customer request'],
      correctAnswer: 1,
      explanation: 'Monitoring rules should be reviewed and updated regularly as new typologies emerge and criminal methods evolve.'
    },
    {
      question: 'What should happen to high-risk transactions?',
      options: ['Approve immediately', 'Escalate for enhanced review and potentially file SAR', 'Block without review', 'Inform the customer'],
      correctAnswer: 1,
      explanation: 'High-risk transactions should be escalated for enhanced due diligence review and potential SAR filing if indicators warrant.'
    },
    {
      question: 'What information should transaction monitoring rules consider?',
      options: ['Only transaction amount', 'Amount, customer risk profile, counterparty, jurisdiction, frequency, and patterns', 'Only customer name', 'Only account type'],
      correctAnswer: 1,
      explanation: 'Effective monitoring considers: transaction amount, customer risk level, counterparty information, jurisdiction, transaction frequency, and activity patterns.'
    },
    {
      question: 'What is the role of transaction monitoring in preventing money laundering?',
      options: ['No real role', 'Critical - detects suspicious patterns that may indicate laundering activities', 'Only handles complaints', 'Documents transactions after the fact'],
      correctAnswer: 1,
      explanation: 'Transaction monitoring is a critical defense against money laundering by detecting suspicious patterns and activities in real-time or near real-time.'
    }
  ],
  'Transaction Monitoring': [
    {
      question: 'What is the purpose of transaction monitoring?',
      options: ['Increase processing fees', 'Detect suspicious patterns and AML red flags', 'Slow down customer service', 'Create additional paperwork'],
      correctAnswer: 1,
      explanation: 'Transaction monitoring detects suspicious transaction patterns and activities that may indicate money laundering or other financial crimes.'
    },
    {
      question: 'What are typical transaction monitoring rules?',
      options: ['Arbitrary limitations', 'Threshold-based (e.g., >$50k), pattern-based, and behavioral rules', 'No rules needed', 'Customer preferences'],
      correctAnswer: 1,
      explanation: 'Effective monitoring uses threshold-based rules (large amounts), pattern-based rules (rapid movements), and behavioral rules (changes in activity).'
    },
    {
      question: 'What is a false positive in transaction monitoring?',
      options: ['A legitimate transaction flagged as suspicious', 'A suspicious transaction that goes undetected', 'A customer complaint', 'A system error'],
      correctAnswer: 0,
      explanation: 'A false positive is a legitimate transaction that triggers a monitoring alert, requiring investigation to clear.'
    },
    {
      question: 'What should be the next step after a transaction is flagged?',
      options: ['Immediately block the transaction', 'Investigate to determine if truly suspicious', 'Ignore it', 'Notify the customer'],
      correctAnswer: 1,
      explanation: 'Flagged transactions should be investigated thoroughly to determine if they\'re genuinely suspicious or false positives.'
    },
    {
      question: 'How does behavioral monitoring work?',
      options: ['Monitor customer behavior outside of banking', 'Track changes in customer transaction patterns from their baseline', 'Listen to customer calls', 'Track customer location'],
      correctAnswer: 1,
      explanation: 'Behavioral monitoring detects unusual changes in a customer\'s transaction patterns compared to their established baseline activity.'
    },
    {
      question: 'What is a transaction with a high-risk jurisdiction?',
      options: ['Any international transaction', 'Transactions involving countries with weak AML controls or sanction risks', 'Transactions that cross state lines', 'Large wire transfers'],
      correctAnswer: 1,
      explanation: 'High-risk jurisdictions are countries with weak AML controls, corruption, or involved in sanctions. Transactions to/from these need enhanced monitoring.'
    },
    {
      question: 'How often should monitoring rules be reviewed and updated?',
      options: ['Never - set once and forget', 'Regularly (quarterly/annually) based on evolving threats and patterns', 'Only when there\'s a major incident', 'Customer request'],
      correctAnswer: 1,
      explanation: 'Monitoring rules should be reviewed and updated regularly as new typologies emerge and criminal methods evolve.'
    },
    {
      question: 'What should happen to high-risk transactions?',
      options: ['Approve immediately', 'Escalate for enhanced review and potentially file SAR', 'Block without review', 'Inform the customer'],
      correctAnswer: 1,
      explanation: 'High-risk transactions should be escalated for enhanced due diligence review and potential SAR filing if indicators warrant.'
    },
    {
      question: 'What information should transaction monitoring rules consider?',
      options: ['Only transaction amount', 'Amount, customer risk profile, counterparty, jurisdiction, frequency, and patterns', 'Only customer name', 'Only account type'],
      correctAnswer: 1,
      explanation: 'Effective monitoring considers: transaction amount, customer risk level, counterparty information, jurisdiction, transaction frequency, and activity patterns.'
    },
    {
      question: 'What is the role of transaction monitoring in preventing money laundering?',
      options: ['No real role', 'Critical - detects suspicious patterns that may indicate laundering activities', 'Only handles complaints', 'Documents transactions after the fact'],
      correctAnswer: 1,
      explanation: 'Transaction monitoring is a critical defense against money laundering by detecting suspicious patterns and activities in real-time or near real-time.'
    }
  ],

  'transaction-analysis': [
    {
      question: 'What is the first step in transaction analysis?',
      options: ['File a SAR immediately', 'Establish baseline customer behavior first', 'Contact law enforcement', 'Close the account'],
      correctAnswer: 1,
      explanation: 'Understanding normal customer behavior establishes the baseline needed to identify deviations that indicate suspicious activity.'
    },
    {
      question: 'What should you do when customer activity suddenly deviates from baseline?',
      options: ['Ignore it if it seems profitable', 'Investigate the reason for the change', 'Automatically file SAR', 'Ask customer to stop the activity'],
      correctAnswer: 1,
      explanation: 'Sudden deviations from normal behavior require investigation to determine if legitimate explanation exists or if it indicates money laundering.'
    },
    {
      question: 'How long should a typical transaction analysis review cover?',
      options: ['Last transaction only', '6-12 months of activity', 'Only current year', '5+ years'],
      correctAnswer: 1,
      explanation: 'A 6-12 month review period provides sufficient transaction history to establish patterns while remaining manageable in scope.'
    },
    {
      question: 'What is velocity analysis in transaction monitoring?',
      options: ['Speed of analysis reporting', 'Examining transaction frequency and speed', 'Customer walking speed in bank', 'Time for SAR filing'],
      correctAnswer: 1,
      explanation: 'Velocity analysis examines how fast funds move through accounts, which can indicate integration phase money laundering.'
    },
    {
      question: 'When writing a transaction analysis, facts and conclusions should be:',
      options: ['Combined together', 'Separated so conclusions are supported by facts', 'Only include conclusions', 'Facts are irrelevant'],
      correctAnswer: 1,
      explanation: 'Effective analysis clearly distinguishes facts (what happened) from conclusions (what it means) so readers understand the reasoning.'
    },
    {
      question: 'What is a key red flag in transaction analysis?',
      options: ['Customer making regular deposits', 'Funds rapid deposit-to-withdrawal cycle', 'Using the same bank consistently', 'Following business seasonal patterns'],
      correctAnswer: 1,
      explanation: 'Rapid deposit-to-withdrawal cycles suggest funds are moving through the account, not being used, which is consistent with money laundering integration.'
    },
    {
      question: 'How should you handle potential mitigating factors in analysis?',
      options: ['Ignore them completely', 'Include and explain whether they resolve concerns', 'Only mention if they clear customer', 'Exclude from report'],
      correctAnswer: 1,
      explanation: 'Professional analysis addresses mitigating factors and explains whether they adequately resolve the suspicious indicators.'
    },
    {
      question: 'What geographic analysis looks for in international transactions?',
      options: ['Only warm weather countries', 'Funds to/from countries, consistency with business type, and destination risk', 'Customers home country', 'Bank location only'],
      correctAnswer: 1,
      explanation: 'Geographic analysis examines where funds go, whether it aligns with business operations, and associated risk of destination countries.'
    },
    {
      question: 'When should you document transaction analysis findings?',
      options: ['Never - keep it verbal', 'Only if you file SAR', 'Immediately when analysis is complete', 'Several months later'],
      correctAnswer: 2,
      explanation: 'Prompt documentation of findings creates clear record of analysis and decision-making for regulatory examination purposes.'
    },
    {
      question: 'What is trade-based money laundering (TBML)?',
      options: ['Normal international trade', 'Using international commerce to move illicit funds through over/under-invoicing', 'Trading stocks illegally', 'Selling traded goods'],
      correctAnswer: 1,
      explanation: 'TBML uses international trade discrepancies (inflated invoices, circular trades) to extract or inject illicit funds into legitimate commerce.'
    }
  ],

  'sar-writing': [
    {
      question: 'What is the primary requirement for filing a SAR?',
      options: ['Proof of crime', 'Suspicious transaction that meets threshold', 'Customer confession', 'Law enforcement request'],
      correctAnswer: 1,
      explanation: 'SARs must be filed for suspicious transactions; proof of crime is not required - suspicion based on indicators is sufficient.'
    },
    {
      question: 'What is the SAR filing deadline?',
      options: ['Immediately', '15 days', '30 calendar days from detection', '60 days'],
      correctAnswer: 2,
      explanation: 'SAR must be filed within 30 calendar days of detecting the suspicious activity, counting all days including weekends.'
    },
    {
      question: 'What protects you from liability when filing a good faith SAR?',
      options: ['Nothing - always risky', 'Safe harbor provision', 'Manager approval only', 'Customer notification'],
      correctAnswer: 1,
      explanation: 'Safe harbor protection shields institutions and employees from liability for good faith SAR filings even if activity later proves legal.'
    },
    {
      question: 'What should you do if a customer directly asks about a SAR filing?',
      options: ['Confirm the filing', 'Deny it and close the account', 'Do not disclose - maintain confidentiality', 'File another SAR about the question'],
      correctAnswer: 2,
      explanation: 'SARs must be kept strictly confidential; disclosing SAR filing violates regulations and can result in criminal penalties.'
    },
    {
      question: 'When writing the SAR narrative, what should you emphasize?',
      options: ['Customer demographics', 'How suspicious the activity is', 'Why you believe crime occurred based on facts and indicators', 'Teller gossip'],
      correctAnswer: 2,
      explanation: 'The narrative should factually explain what activity occurred and why, based on evidence, suspicious indicators, and professional judgment, it warrants reporting.'
    },
    {
      question: 'How should facts and conclusions be presented in SAR narrative?',
      options: ['Combine them freely', 'Present facts, then explain conclusions supported by those facts', 'Only include conclusions', 'Ignore facts'],
      correctAnswer: 1,
      explanation: 'Effective SAR narratives present factual basis first, then professionally interpret what those facts suggest about the activity.'
    },
    {
      question: 'What information is required in the SAR Party Details section?',
      options: ['Only account holder name', 'Account holder, beneficial owner, other parties involved with account numbers', 'Only addresses', 'Age of all parties'],
      correctAnswer: 1,
      explanation: 'Complete party information includes primary account holder, beneficial owner if different, and other parties involved in transaction.'
    },
    {
      question: 'When should you file a supplemental SAR?',
      options: ['Never - one SAR per case', 'When new information emerges supporting the original suspicious activity', 'Only at year-end', 'When closing the account'],
      correctAnswer: 1,
      explanation: 'Supplemental SARs document pattern continuation or new evidence discovered after initial filing that further supports suspicious activity.'
    },
    {
      question: 'What makes a strong SAR narrative?',
      options: ['Vague suspicions', 'Specific facts, timeline, indicators, and why activity is suspicious', 'Long rambling paragraphs', 'Customer complaints'],
      correctAnswer: 1,
      explanation: 'Strong SARs provide chronological facts, specific indicators, dollar amounts, dates, and clear reasoning connecting facts to suspicion.'
    },
    {
      question: 'What should you do with SAR supporting documentation?',
      options: ['Discard after filing', 'Keep in customer file with SAR reference', 'Keep separate confidential file, maintain at least 5 years', 'Share with customer'],
      correctAnswer: 2,
      explanation: 'SAR supporting documents must be maintained separately in confidential files for minimum 5 years for regulatory examination access.'
    }
  ],

  'crypto-investigations': [
    {
      question: 'What is the primary AML challenge with cryptocurrency?',
      options: ['It only exists online', 'Pseudonymity enables transactions without clear identity verification', 'It is never used illegally', 'Bitcoins are too expensive'],
      correctAnswer: 1,
      explanation: 'Cryptocurrency addresses are pseudonymous (not anonymous), making it difficult to identify transaction parties without additional investigation.'
    },
    {
      question: 'What are mixing/tumbling services in cryptocurrency?',
      options: ['Services that combine different coins', 'Services that hide transaction origins by mixing funds with others', 'Bank account services', 'Investment platforms'],
      correctAnswer: 1,
      explanation: 'Mixing services intentionally break transaction chains by combining customer crypto with others, creating AML compliance concerns.'
    },
    {
      question: 'How do you trace a Bitcoin transaction on blockchain?',
      options: ['You cannot - Bitcoin is completely anonymous', 'Use blockchain analysis tools to follow address transactions', 'Contact Bitcoin government', 'Use magic'],
      correctAnswer: 1,
      explanation: 'Blockchain analysis tools like Chainalysis can trace Bitcoin transactions by following wallet addresses on the immutable public ledger.'
    },
    {
      question: 'What red flag indicates potential sanctions evasion in crypto?',
      options: ['Any cryptocurrency use', 'Transactions to wallet addresses linked to sanctioned entities', 'Buying Bitcoin', 'US exchange transactions'],
      correctAnswer: 1,
      explanation: 'Transactions to addresses previously linked to sanctioned entities or OFAC-designated parties constitute sanctions violations.'
    },
    {
      question: 'What should you ask customers about cryptocurrency sources?',
      options: ['Nothing - it is personal', 'Where the cryptocurrency came from and why converting to/from fiat', 'Only if amount over $1M', 'Never ask questions'],
      correctAnswer: 1,
      explanation: 'Enhanced KYC for crypto customers should clarify source of crypto, business purpose for conversion, and recipient/sender information.'
    },
    {
      question: 'What is ransomware payment risk in cryptocurrency?',
      options: ['No risk exists', 'Criminals demand ransomware payments in crypto, making detection and prevention difficult', 'Ransomware only targets banks', 'Crypto makes ransom impossible'],
      correctAnswer: 1,
      explanation: 'Ransomware gangs often demand Bitcoin or other crypto, creating AML risk as victims may unknowingly facilitate criminal payments.'
    },
    {
      question: 'What does DeFi (Decentralized Finance) mean for AML?',
      options: ['More regulated than traditional finance', 'Financial services without central authority or KYC, creating compliance gaps', 'Only approved by governments', 'No compliance needed'],
      correctAnswer: 1,
      explanation: 'DeFi platforms typically lack KYC and central oversight, making them difficult to monitor for suspicious activity or sanctions compliance.'
    },
    {
      question: 'How should staking services be evaluated for AML risk?',
      options: ['They are always safe', 'Verify legitimacy, assess custody risk, check regulatory compliance', 'Never use staking', 'Governments endorse all staking'],
      correctAnswer: 1,
      explanation: 'Due diligence on crypto earning platforms should verify service legitimacy, understand custody risks, and assess regulatory compliance.'
    },
    {
      question: 'What is Monero and why is it concerning for AML?',
      options: ['A type of blockchain explorer', 'Privacy coin with ring signatures designed for anonymity, raising regulatory concerns', 'A centralized exchange', 'A type of mining'],
      correctAnswer: 1,
      explanation: 'Monero is explicitly designed for anonymity using ring signatures and stealth addresses, leading many exchanges to delist it due to AML concerns.'
    },
    {
      question: 'When should you file a SAR for cryptocurrency activity?',
      options: ['Never - crypto activity is always legal', 'When suspicious patterns detected (mixing services, sanctions involvement, fraud)', 'Only for Bitcoin', 'Only if FBI requests'],
      correctAnswer: 1,
      explanation: 'SARs should be filed for suspicious crypto activity including use of mixing services, sanctioned entity involvement, or other AML indicators.'
    }
  ],

  'structuring-detection': [
    {
      question: 'What is structuring (smurfing)?',
      options: ['Small deposit accounts', 'Breaking transactions into smaller amounts to avoid reporting thresholds', 'Slow deposit processing', 'Multiple bank customers'],
      correctAnswer: 1,
      explanation: 'Structuring deliberately breaks larger transactions into smaller ones to evade CTR ($10K) and SAR ($5K) reporting requirements.'
    },
    {
      question: 'Is structuring illegal even if the underlying funds are legal?',
      options: ['No - only illegal if money came from crime', 'Yes - structuring itself is a federal crime regardless of fund source', 'Only illegal on Fridays', 'Never illegal'],
      correctAnswer: 1,
      explanation: 'Structuring violates 31 USC 5324 regardless of whether funds originated from legal or illegal sources.'
    },
    {
      question: 'What is the most common deposit structuring pattern?',
      options: ['Large deposits once monthly', 'Multiple deposits of $9,800-$9,900 just under CTR threshold', 'Deposits only on Mondays', 'Withdrawals exceeding deposits'],
      correctAnswer: 1,
      explanation: 'Classic structuring involves consistent deposits just below the $10,000 CTR threshold ($9,800, $9,900), demonstrating intent to avoid reporting.'
    },
    {
      question: 'What timing indicator suggests structuring?',
      options: ['Deposits in morning only', 'Deposits only business days, avoiding weekends when amounts might exceed threshold', 'Deposits at midnight', 'Deposits in summer only'],
      correctAnswer: 1,
      explanation: 'Deliberate timing patterns, such as deposits only M-F to control weekly totals, indicate intentional structuring rather than natural business flow.'
    },
    {
      question: 'When is deposit variation a structuring red flag?',
      options: ['All amounts exactly identical', 'Amounts vary slightly ($9,200, $9,500, $9,800) but stay consistently below threshold', 'Amounts increase monthly', 'Amounts decrease over time'],
      correctAnswer: 1,
      explanation: 'Slight variation in amounts while maintaining below-threshold total suggests deliberate calculation to appear random while avoiding reporting.'
    },
    {
      question: 'What should you do immediately when structuring is detected?',
      options: ['Continue processing deposits normally', 'Stop facilitating deposits and report to compliance officer', 'Warn the customer', 'File SAR immediately without investigation'],
      correctAnswer: 1,
      explanation: 'Upon detecting structuring, stop facilitating the pattern, document observations, and escalate to compliance for investigation and SAR filing decision.'
    },
    {
      question: 'How can you distinguish structuring from legitimate high-cash business deposits?',
      options: ['You cannot - all patterns are legitimate', 'Assess business documentation, consistency with business model, and customer explanations', 'Business deposits are always legal', 'Only by customer age'],
      correctAnswer: 1,
      explanation: 'Legitimate businesses should have supporting documentation and logical explanations for deposits that align with documented revenue and business operations.'
    },
    {
      question: 'What is layering in the context of structuring?',
      options: ['Physical stacking of cash', 'Using multiple accounts to hide trail of funds through transfers', 'Loan structures', 'Interest calculations'],
      correctAnswer: 1,
      explanation: 'Layering involves transfers between multiple accounts to obscure fund origins, often used in conjunction with deposit structuring.'
    },
    {
      question: 'What criminal penalty applies to structuring convictions?',
      options: ['Warning letter only', 'Up to 5 years imprisonment and fines up to $250,000+, with forfeiture of structured amounts', 'Never prosecuted', 'Civil penalties only'],
      correctAnswer: 1,
      explanation: 'Federal structuring violations carry serious penalties including prison time and significant fines, with structured funds subject to civil forfeiture.'
    },
    {
      question: 'What content should a structuring SAR include?',
      options: ['Customer name only', 'Description of structured pattern, specific deposit amounts/dates, total amounts, and no legitimate business explanation', 'Only large transactions', 'No specific details needed'],
      correctAnswer: 1,
      explanation: 'Effective structuring SARs document the pattern clearly (amounts, dates, total), demonstrate deliberate intent, and explain absence of legitimate rationale.'
    }
  ],

  'ai-in-compliance': [
    {
      question: 'What is AI hallucination in the context of compliance?',
      options: ['A type of compliance violation', 'When AI generates false information that sounds plausible', 'A method for detecting fraud', 'A way to train AI models'],
      correctAnswer: 1,
      explanation: 'AI hallucinations occur when artificial intelligence generates false information with confidence, which is particularly dangerous in compliance work where accuracy is critical.'
    },
    {
      question: 'What should you do before relying on AI output for a compliance decision?',
      options: ['Use it immediately', 'Always verify AI output against primary data sources', 'Ask other AI systems to confirm', 'Trust the AI completely'],
      correctAnswer: 1,
      explanation: 'AI output should always be verified independently before making critical compliance decisions, as AI can make mistakes even when appearing confident.'
    },
    {
      question: 'What is AI bias in compliance applications?',
      options: ['Preferring certain AI vendors', 'When AI models perpetuate unfair patterns from training data or design', 'Using multiple AI systems', 'AI being too efficient'],
      correctAnswer: 1,
      explanation: 'Bias in AI compliance systems can occur when training data itself is biased or when the model design perpetuates unfair patterns, potentially discriminating against certain customer groups.'
    },
    {
      question: 'What does "human-in-the-loop" mean for AI in compliance?',
      options: ['Humans operate all AI systems', 'AI generates assessment → Human reviews → Human makes final decision', 'Removing human involvement from decisions', 'Using only AI without human oversight'],
      correctAnswer: 1,
      explanation: 'Human-in-the-loop means AI assists by generating initial assessments, but humans review, validate, and make the final compliance decision, maintaining human accountability.'
    },
    {
      question: 'What is model drift in AI systems?',
      options: ['Turning off the AI model', 'When AI model performance degrades over time due to changed market conditions or data patterns', 'Moving AI to a different server', 'Training the model incorrectly'],
      correctAnswer: 1,
      explanation: 'Model drift occurs when the patterns an AI model learned become less relevant over time due to market changes, regulatory updates, or customer behavior evolution, requiring retraining.'
    },
    {
      question: 'Which of these is a genuine benefit of AI in compliance?',
      options: ['Eliminates need for compliance staff', 'Processes thousands of transactions at scale while maintaining consistency', 'Replaces all human judgment', 'Guarantees 100% accuracy'],
      correctAnswer: 1,
      explanation: 'AI genuinely excels at processing large volumes efficiently and applying rules consistently, but should augment human judgment, not replace it.'
    },
    {
      question: 'What is a critical limitation of AI hallucinations?',
      options: ['They make AI work too fast', 'AI can confidently state false information that sounds completely plausible', 'They only affect small models', 'There is no limitation'],
      correctAnswer: 1,
      explanation: 'The danger of hallucinations is that AI presents false information with confidence, making it difficult to detect without verification - analysts might believe false claims.'
    },
    {
      question: 'When training AI for compliance tasks, what is most critical?',
      options: ['Using any available data', 'Using high-quality labeled data from compliance experts with representative examples', 'Training on as much data as possible', 'Using only recent data'],
      correctAnswer: 1,
      explanation: 'High-quality training data verified by compliance experts, including edge cases and diverse scenarios, is essential for AI to learn appropriate compliance decision-making.'
    },
    {
      question: 'How should AI be used for SAR drafting?',
      options: ['AI writes SAR and analyst files it', 'AI generates draft → Analyst reviews → Analyst verifies and approves', 'AI alone determines if SAR needed', 'Never use AI for SARs'],
      correctAnswer: 1,
      explanation: 'AI can assist by drafting initial narratives, but the analyst must review, verify accuracy, and make the final decision before filing the SAR with FinCEN.'
    },
    {
      question: 'What privacy concern exists when using AI tools for compliance?',
      options: ['AI is always private and secure', 'Sensitive customer data sent to external AI services may be retained, used for training, or stored outside your control', 'AI has no privacy concerns', 'Only internal AI has privacy issues'],
      correctAnswer: 1,
      explanation: 'When using external AI services, sensitive compliance data may be retained by the provider, potentially used for model training, raising significant privacy and regulatory concerns.'
    }
  ]
};

// Populate AML Foundations with all language versions
quizQuestions['AML Foundations'].en = quizQuestions['aml-foundations'].en;
quizQuestions['AML Foundations'].es = quizQuestions['aml-foundations'].es;
quizQuestions['AML Foundations'].pt = quizQuestions['aml-foundations'].pt;

// Add module ID aliases for kebab-case lookups
quizQuestions['transaction-analysis'] = quizQuestions['transaction-analysis'] || {};
quizQuestions['sar-writing'] = quizQuestions['sar-writing'] || {};
quizQuestions['crypto-investigations'] = quizQuestions['crypto-investigations'] || {};
quizQuestions['structuring-detection'] = quizQuestions['structuring-detection'] || {};
quizQuestions['ai-in-compliance'] = quizQuestions['ai-in-compliance'] || {};

// Ensure all modules have default English versions if not already structured
if (Array.isArray(quizQuestions['transaction-analysis'])) {
  quizQuestions['transaction-analysis'] = { en: quizQuestions['transaction-analysis'], es: [], pt: [] };
}
if (Array.isArray(quizQuestions['sar-writing'])) {
  quizQuestions['sar-writing'] = { en: quizQuestions['sar-writing'], es: [], pt: [] };
}
if (Array.isArray(quizQuestions['crypto-investigations'])) {
  quizQuestions['crypto-investigations'] = { en: quizQuestions['crypto-investigations'], es: [], pt: [] };
}
if (Array.isArray(quizQuestions['structuring-detection'])) {
  quizQuestions['structuring-detection'] = { en: quizQuestions['structuring-detection'], es: [], pt: [] };
}
if (Array.isArray(quizQuestions['ai-in-compliance'])) {
  quizQuestions['ai-in-compliance'] = { en: quizQuestions['ai-in-compliance'], es: [], pt: [] };
}

// Financial Intelligence Against Human Trafficking
quizQuestions['financial-intel-trafficking'] = {
  'en': [
  {
    question: 'What are the two primary forms of human trafficking?',
    options: ['Sex trafficking and labor trafficking', 'Domestic and international trafficking', 'Adult and minor trafficking', 'Organized and independent trafficking'],
    correctAnswer: 0,
    explanation: 'The two primary forms are sex trafficking (forced commercial sex acts) and labor trafficking (forced labor or services). Both are federal crimes under the Trafficking Victims Protection Act.'
  },
  {
    question: 'What is the estimated annual revenue from sex trafficking in the 25 largest US cities?',
    options: ['$99 million', '$150 billion', '$25 million', '$500 million'],
    correctAnswer: 0,
    explanation: 'According to the Urban Institute, sex trafficking generates approximately $99 million annually in the 25 largest US cities. Global trafficking revenue is estimated at $150 billion annually.'
  },
  {
    question: 'Which of the following is the most consistent financial signature of sex trafficking?',
    options: ['Third-party cash deposits', 'Large wire transfers', 'Monthly credit card charges', 'Consistent payroll deposits'],
    correctAnswer: 0,
    explanation: 'Third-party cash deposits—when someone other than the account holder makes regular cash deposits—is the single most consistent financial indicator of sex trafficking.'
  },
  {
    question: 'What should you do if you suspect a customer is a trafficking victim?',
    options: ['Never directly question them; investigate through records', 'Ask them directly if they are a victim', 'Contact law enforcement immediately', 'Freeze their account without explanation'],
    correctAnswer: 0,
    explanation: 'Never directly question a potential victim about trafficking. Doing so could endanger them, alert the trafficker, or disrupt a law enforcement investigation. Investigate through existing records only.'
  },
  {
    question: 'Which transaction pattern is a key indicator of labor trafficking?',
    options: ['Below-minimum-wage payroll to multiple workers', 'Large monthly salary deposits', 'Regular utility and rent payments', 'Consistent investment account transfers'],
    correctAnswer: 0,
    explanation: 'Labor trafficking is often revealed through payroll patterns showing wages significantly below market rate or minimum wage, suggesting workers are receiving only a fraction of their earned compensation.'
  },
  {
    question: 'What is the Polaris Project\'s National Human Trafficking Hotline number?',
    options: ['1-888-373-7888', '1-800-767-2839', '1-855-873-2546', '1-877-337-5262'],
    correctAnswer: 0,
    explanation: 'The Polaris Project National Human Trafficking Hotline is 1-888-373-7888. This number should be included in every trafficking-related SAR and connects victims with law enforcement coordination.'
  },
  {
    question: 'Which business types are most commonly used as fronts for sex trafficking?',
    options: ['Massage parlors, nail salons, escort agencies, entertainment companies', 'Grocery stores, gas stations, hardware stores, pharmacies', 'Hospitals, dental offices, veterinary clinics, legal offices', 'Manufacturing plants, construction firms, tech companies, financial services'],
    correctAnswer: 0,
    explanation: 'Common sex trafficking front businesses include massage parlors, nail salons, escort agencies, and entertainment companies. These provide cover for high cash revenue and frequent customer turnover.'
  },
  {
    question: 'What is the FIHT Framework?',
    options: ['Detection, Documentation, and Disruption', 'Forensics, Investigation, Human resources, Training', 'Federal, Institutional, Human, Trafficking', 'Financial, Intelligence, Identification, Tracking'],
    correctAnswer: 0,
    explanation: 'The Financial Intelligence Against Human Trafficking (FIHT) Framework is organized around three pillars: Detection (identifying trafficking patterns), Documentation (recording indicators for SAR/investigation), and Disruption (supporting law enforcement action).'
  },
  {
    question: 'When should a trafficking SAR be filed?',
    options: ['Within 30 days of detecting suspicious activity; use trafficking-specific SAR category', 'Within 60 days using generic categories', 'Only when law enforcement makes a direct request', 'When the institution is certain trafficking occurred'],
    correctAnswer: 0,
    explanation: 'Trafficking SARs must be filed within 30 days using the specific trafficking SAR category (sex trafficking or labor trafficking). Do not use generic categories—they reduce law enforcement utility.'
  },
  {
    question: 'What is a key difference between labor trafficking and sex trafficking financially?',
    options: ['Labor trafficking involves wage diversion; sex trafficking involves cash revenue from commercial sex', 'Labor trafficking uses cryptocurrencies; sex trafficking uses bank transfers', 'Labor trafficking requires third-party deposits; sex trafficking does not', 'Labor trafficking involves only wire transfers; sex trafficking involves only cash'],
    correctAnswer: 0,
    explanation: 'The key distinction is revenue source: sex trafficking generates revenue from commercial sex transactions (cash-based), while labor trafficking diverts legitimate wages that should belong to victims through controlled accounts.'
  }
  ],
  'es': [],
  'pt': []
};

// Map database module IDs to quiz questions
quizQuestions['kyc-procedures'] = quizQuestions['Know Your Customer (KYC)'] || [];
quizQuestions['sanctions-screening'] = quizQuestions['Sanctions & OFAC Compliance'] || [];
quizQuestions['sar-reporting'] = quizQuestions['Suspicious Activity Reporting (SAR)'] || [];
quizQuestions['data-protection'] = quizQuestions['data-protection'] || [
  { question: 'What is the primary purpose of data protection regulations?', options: ['Protect personal information from misuse', 'Increase company revenue', 'Reduce customer base', 'Eliminate privacy'], correctAnswer: 0, explanation: 'Data protection regulations aim to protect personal information from unauthorized access and misuse.' },
  { question: 'What does GDPR stand for?', options: ['General Data Protection Regulation', 'Global Data Processing Rule', 'Government Data Protection Rights', 'General Digital Privacy Requirement'], correctAnswer: 0, explanation: 'GDPR stands for General Data Protection Regulation, the EU\'s data protection law.' },
  { question: 'What must you do before collecting customer data?', options: ['Obtain informed consent', 'Collect data first, ask later', 'Use data without notice', 'Share with third parties'], correctAnswer: 0, explanation: 'You must obtain informed consent from customers before collecting their personal data.' },
  { question: 'What is a data breach?', options: ['Unauthorized access to personal information', 'Deleting customer accounts', 'Updating security systems', 'Creating backup files'], correctAnswer: 0, explanation: 'A data breach is unauthorized access to or disclosure of personal information.' },
  { question: 'How long must data be retained?', options: ['Only as long as necessary for business purpose', 'Forever', '3 years maximum', 'Until customer requests deletion'], correctAnswer: 0, explanation: 'Data should be retained only as long as necessary for the stated business purpose, then securely deleted.' },
  { question: 'What is encryption?', options: ['Converting data into unreadable format using a key', 'Deleting sensitive information', 'Backing up data', 'Printing documents'], correctAnswer: 0, explanation: 'Encryption converts data into unreadable format using a key, protecting it during transmission and storage.' },
  { question: 'What should you do if a customer requests their data?', options: ['Provide it promptly and in usable format', 'Refuse the request', 'Charge a large fee', 'Take 3 months to respond'], correctAnswer: 0, explanation: 'You must provide customer data promptly and in a usable format when requested (data subject access rights).' },
  { question: 'What is CCPA?', options: ['California Consumer Privacy Act', 'Customer Credit Policies Act', 'Corporate Communication Privacy Agreement', 'Compliance Certification Procedure Agreement'], correctAnswer: 0, explanation: 'CCPA is the California Consumer Privacy Act, protecting consumer privacy in California.' },
  { question: 'What must you do immediately upon discovering a breach?', options: ['Notify affected individuals and authorities', 'Keep it quiet', 'Wait for a lawsuit', 'Blame the customer'], correctAnswer: 0, explanation: 'You must notify affected individuals and relevant authorities immediately upon discovering a data breach.' },
  { question: 'What is a Data Protection Officer (DPO)?', options: ['Responsible for data protection compliance', 'Handles customer complaints only', 'Approves all transactions', 'Manages IT department'], correctAnswer: 0, explanation: 'A Data Protection Officer is responsible for ensuring data protection compliance within the organization.' }
];
